export default "__VITE_ASSET__DmZ3Q7aE__";